import { useState, useEffect } from "react";
import swal from "sweetalert2";
import moment from "moment";
import Select from "react-select";
import { getVendorBookingReportData } from "../api/reportsAPI";
import { getVendorMasterAll } from "../api/vendorAPI";

const allPartnersOption = { label: "All Partners", value: 0 };

const VendorBookingReport = (props) => {
  const [selectedFromDate, setSelectedFromDate] = useState(moment().toDate());
  const [selectedToDate, setSelectedToDate] = useState(moment().toDate());
  const [selectedVendor, setSelectedVendor] = useState(allPartnersOption);
  const [vendorList, setVendorList] = useState([]);
  const [isInit, setIsInit] = useState(true);
  const [bookingReport, setBookingReport] = useState(null);
  const [bookingTable, setBookingTable] = useState(null);

  useEffect(() => {
    props.title("Partner Booking Report", "vendor-booking-report");

    $("#txtFromDate").datepicker({
      format: "dd-mm-yyyy",
      minDate: new Date(),
    });
    $("#txtFromDate").on("change", function (event) {
      setSelectedFromDate(event.target.value);
    });
    $("#txtToDate").datepicker({
      format: "dd-mm-yyyy",
      minDate: new Date(),
    });
    $("#txtToDate").on("change", function (event) {
      setSelectedToDate(event.target.value);
    });
    fetchVendorMaster();
    getBookingReport();
  }, []);

  useEffect(() => {
    if (!isInit) {
      fillTable();
    }
  }, [bookingReport]);

  useEffect(()=>{
    if(!selectedVendor) return;
    validateDate()   
  },[selectedVendor])

  const fetchVendorMaster = async () => {
    try {
      const vendors = await getVendorMasterAll();
      setVendorList(vendors || []);
    } catch (err) {
      swal.fire({
        icon: "error",
        titleText: err.message,
      });
    }
  };

  const getBookingReport = async () => {
    try {
      swal.fire({
        titleText: "Loading",
        text: "Please Wait...",
        showConfirmButton: false,
        onOpen: () => {
          swal.showLoading();
        },
      });

      const response = await getVendorBookingReportData(
        moment(selectedFromDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        moment(selectedToDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        selectedVendor?.value || 0
      );

      isInit
        ? setIsInit(false)
        : $("#tblVendorBookingReport").KTDatatable().destroy();

      setBookingReport(response);

      swal.close();
    } catch (err) {
      swal.fire({
        icon: "error",
        titleText: err.message,
      });
    }
  };

  function fillTable() {
    swal.close();

    const reportSheet = bookingReport?.ReportSheet || [];

    $("#tblVendorBookingReport").KTDatatable({
      data: {
        saveState: false,
        source: reportSheet,
      },
      layout: {
        scroll: false,
        footer: false,
      },
      sortable: false,
      pagination: false,
      search: {
        input: $("#generalSearch"),
      },
      columns: [
        // { field: "BookingID", title: "Book ID", width: 60 },
        {
          field: "BillDate",
          title: "Bill Dt",
          width: 130,
          template: function (row) {
            if (row.BillDate == null) {
              return "";
            } else {
              return moment(row.BillDate).format("DD-MM-YYYY, h:mm a");
            }
          },
        },
        {
          field: "BookDate",
          title: "Game Dt",
          width: 80,
          template: function (row) {
            if (row.BookDate == null) {
              return "";
            } else {
              return moment(row.BookDate).format("DD-MM-YYYY");
            }
          },
        },
        { field: "Slot", title: "Slot", width: 60 },
        { field: "VendorName", title: "Partner", width: 130 },
        { field: "GuestNames", title: "Guests", width: 180 },
        // { field: "TeeBox", title: "TeeBox", width: 45 },
        { field: "Hole", title: "Holes", width: 40 },
        { field: "TrackingID", title: "Tracking ID", width: 120 },
        { field: "InvoiceNo", title: "Invoice No", width: 140 },        
        { field: "PaymentModeName", title: "Pay.Type", width: 100 },
        { field: 'PaymentMethodName', title: 'Pay.Mode', width: 70 },
        { field: "TotalPlayer", title: "Players", width: 60 },
        { field: "GreenFee", title: "Green Fee", width: 80 },
        { field: "CartCount", title: "No of Cart", width: 80 },
        { field: "CartFee", title: "Cart Fee", width: 80 },
        { field: "CaddyCount", title: "No of Caddy", width: 80 },
        { field: "CaddyFee", title: "Caddy Fee", width: 80 },
        { field: "Tax", title: "Tax", width: 70 },
        { field: "Amount", title: "Total Amt", width: 80 },
        // {
        //   field: "OrderStatus",
        //   title: "Payment",
        //   width: 80,
        //   template: function (row) {
        //     return row.OrderStatus || "-";
        //   },
        // },
      ],
      rows: { autoHide: false },
    });

    $("#root .kt-grid--hor").addClass("max-width100");
    $("#tblVendorBookingReport .kt-datatable__table").addClass(
      "overflow-x-auto"
    );

    Config.Core.InitPopover();
    Config.Core.GrabAndScroll(".kt-datatable__table");

    const BookingTable = $(".kt-datatable__table").tableExport({
      formats: ["xlsx", "csv"],
      headers: true,
      filename: `${moment(selectedFromDate).format(
        "DD-MM-YYYY"
      )} - To - ${moment(selectedToDate).format(
        "DD-MM-YYYY"
      )} - Partner Booking Report`,
    });

    setBookingTable(BookingTable);
    $(".tableexport-caption").addClass("hidden");
  }

  function exportSheet(type) {
    let fileName = `${moment(selectedFromDate, "DD-MM-YYYY").format(
      "DD-MM-YYYY"
    )} - To - ${moment(selectedToDate, "DD-MM-YYYY").format(
      "DD-MM-YYYY"
    )} - Partner Booking Report`;
    bookingTable.update({
      headers: true,
      formats: ["xlsx", "csv"],
      filename: fileName,
    });

    if (type == "xlsx") {
      $(".button-default.xlsx").click();
    } else {
      $(".button-default.csv").click();
    }
    $(".tableexport-caption").addClass("hidden");
  }

  const validateDate = async () => {
    if (
      moment(selectedToDate, "DD-MM-YYYY").isBefore(
        moment(selectedFromDate, "DD-MM-YYYY")
      )
    ) {
      swal.fire({
        icon: "error",
        titleText: "Oops..",
        text: "To Date should be greater than From Date",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-brand",
      });
      return;
    }
    getBookingReport();
  };
 
  return (
    <>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0"
        id="kt_content"
      >
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
          <div className="kt-portlet">
            <div className="kt-portlet__body padding-t20 padding-b0">
              <div
                id="ControlHolder"
                className="kt-form kt-form--label-right padding-10"
                role="form"
              >
                <div className="row">
                  <div className="form-group col-sm-2">
                    <Select
                      onChange={(event) => setSelectedVendor(event)}
                      name="ddlSelectVendor"
                      id="ddlSelectVendor"
                      className="ddlSelectVendor"
                      value={selectedVendor}
                      options={[
                        allPartnersOption,
                        ...vendorList.map((v) => ({
                          label: v.VendorName,
                          value: v.ID,
                        })),
                      ]}
                    />
                  </div>

                  <label className="col-form-label col-sm-1 text-right">
                    From Date
                  </label>
                  <div className="form-group col-sm-2">
                    <div className="input-group date">
                      <input
                        id="txtFromDate"
                        name="txtFromDate"
                        type="text"
                        className="form-control"
                        placeholder="Select date"
                        readOnly={true}
                        defaultValue={moment(
                          selectedFromDate,
                          "DD-MM-YYYY"
                        ).format("DD-MM-YYYY")}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">
                          <i className="la la-calendar-check-o"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <label className="col-form-label col-sm-1 text-right">
                    To Date
                  </label>
                  <div className="form-group col-sm-2">
                    <div className="input-group date">
                      <input
                        id="txtToDate"
                        name="txtToDate"
                        type="text"
                        className="form-control"
                        placeholder="Select date"
                        readOnly={true}
                        defaultValue={moment(
                          selectedFromDate,
                          "DD-MM-YYYY"
                        ).format("DD-MM-YYYY")}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">
                          <i className="la la-calendar-check-o"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                 
                  <div className="col-sm-1">
                    <button
                      className="btn btn-label-success"
                      type="button"
                      id="btnSearch"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={() => validateDate()}
                    >
                      <i className="la la-search"></i>
                    </button>
                  </div>
                  <div className="form-group col-sm-2">
                    <div className="input-group">
                      <div className="kt-input-icon kt-input-icon--left">
                        <input
                          type="text"
                          className="form-control clientSearch"
                          placeholder="Search..."
                          id="generalSearch"
                        />
                        <span className="kt-input-icon__icon kt-input-icon__icon--left">
                          <span>
                            <i className="la la-search"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="dropdown">
                      <button
                        className="btn btn-label-brand dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Export
                      </button>
                      <div
                        className="dropdown-menu "
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                          position: "absolute",
                          willChange: "transform",
                          top: "0px",
                          left: "0px",
                          transform: "translate3d(0px, 38px, 0px)",
                        }}
                      >
                        <button
                          id="btn-export-excel"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("xlsx")}
                        >
                          {" "}
                          Excel
                        </button>
                        <button
                          id="btn-export-csv"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("csv")}
                        >
                          {" "}
                          Csv{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="tblVendorBookingReport"
                className="table table-bordered table-hover custom-datatable"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorBookingReport;
